export default function PHP_arsort() {
  return (
    <div>
      <h1>PHP_arsort</h1>
    </div>
  );
}
